/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Trial_End_Reminder_TitleInputs */

const en_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final 2 Days of Your Plus Trial 🌱🌱`)
};

const ar_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر 2 أيام من النسخة التجريبية🌱🌱 الخاصة بك`)
};

const de_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die letzten 2 Tage Ihrer Plus-Testphase 🌱🌱`)
};

const es_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 2 días de tu prueba Plus 🌱🌱`)
};

const fr_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux derniers jours de votre essai Plus 🌱🌱`)
};

const it_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi 2 giorni della tua prova Plus 🌱🌱`)
};

const ja_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusトライアル終了まであと2日🌱🌱`)
};

const ko_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 무료 체험이 이틀 남았어요 🌱🌱`)
};

const pt_br_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 2 dias do seu teste grátis do Plus 🌱🌱`)
};

const ru_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние 2 дня пробной версии 🌱🌱`)
};

const th_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 วันสุดท้ายของการทดลองใช้ Plus 🌱🌱`)
};

const tr_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Denemenin Son 2 Günü 🌱🌱`)
};

const zh_cn_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把握 Plus 试用的最后两天 🌱🌱`)
};

const zh_tw_dialog_trial_end_reminder_title = /** @type {(inputs: Dialog_Trial_End_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把握 Plus 試用的最後兩天 🌱🌱`)
};

/**
* | output |
* | --- |
* | "Final 2 Days of Your Plus Trial 🌱🌱" |
*
* @param {Dialog_Trial_End_Reminder_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_trial_end_reminder_title = /** @type {((inputs?: Dialog_Trial_End_Reminder_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Trial_End_Reminder_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_trial_end_reminder_title(inputs)
	if (locale === "ar") return ar_dialog_trial_end_reminder_title(inputs)
	if (locale === "de") return de_dialog_trial_end_reminder_title(inputs)
	if (locale === "es") return es_dialog_trial_end_reminder_title(inputs)
	if (locale === "fr") return fr_dialog_trial_end_reminder_title(inputs)
	if (locale === "it") return it_dialog_trial_end_reminder_title(inputs)
	if (locale === "ja") return ja_dialog_trial_end_reminder_title(inputs)
	if (locale === "ko") return ko_dialog_trial_end_reminder_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_trial_end_reminder_title(inputs)
	if (locale === "ru") return ru_dialog_trial_end_reminder_title(inputs)
	if (locale === "th") return th_dialog_trial_end_reminder_title(inputs)
	if (locale === "tr") return tr_dialog_trial_end_reminder_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_trial_end_reminder_title(inputs)
	return zh_tw_dialog_trial_end_reminder_title(inputs)
});